import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {DocumentModel} from '../model/document.model';
import {DocumentSummaryConverter} from './DocumentSummary.converter';
import {Injectable} from '@angular/core';
import {DocumentSignatureConverter} from "../../../signature/api/model/documentSignatureConverter.service";

@Injectable({ providedIn: 'root' })
export class DocumentConverter extends HttpModelConverter<DocumentModel>{

    constructor(private  summaryConverter: DocumentSummaryConverter,
                private signatureConverter: DocumentSignatureConverter){
        super();
    }
    protected createInstance(): DocumentModel {
        return new DocumentModel();
    }

    protected enrichObject(result: DocumentModel, src: DocumentModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.signature = this.signatureConverter.convert(src.signature);
    }
}
